import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'verification-search-results',
    templateUrl: 'verification-search-results.component.html',
    styleUrls: ['verification-search-results.component.scss']
})
export class VerificationSearchResultsComponent {
    @Input() results = [];
    @Input() searchValue = '';
    @Input() contentType = '';
    @Input() checkboxesEnabled = true;

    @Output() onHandleOpen = new EventEmitter();

    constructor() {
    }

    handleResultCheckbox(result) {
        result.checked = !result.checked;
    }

    handleTableRowClick(result) {
        result.collapsed = !result.collapsed;
    }

    handleOpen(result) {
        const item: any = {
            parrotId: result.parrotId,
            title: result.title,
            displayName: result.displayName,
            catalogState: result.catalogState,
            contentType: result.contentType
        };
        this.onHandleOpen.emit(item);
    }

    formatCatalogState(catalogState) {
        return catalogState.split('_').map((item) => {
            return item[0].toUpperCase().concat(item.slice(1));
        }).join(' ');
    }

    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
}



// WEBPACK FOOTER //
// ./src/app/catalog-verification/search-results/verification-search-results.component.ts